import * as React from 'react';
import RoomIcon from './RoomIcon';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { observer } from 'mobx-react';
import { Persona } from 'office-ui-fabric-react/lib/Persona';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { wrapWithLocationCard } from 'owa-location-card-v2';

export interface RoomIconProps {
    name: string;
    emailAddress: string;
    secondaryText: string;
    className?: string;
    colorScheme: ColorScheme;
}

/**
 * This is the location bean shown in the location well control.
 */
@observer
export default class RoomPersona extends React.Component<RoomIconProps, any> {
    render() {
        let { name, emailAddress, secondaryText, colorScheme, className } = this.props;
        let roomElement = (
            <Persona
                primaryText={name}
                size={PersonaSize.size32}
                secondaryText={secondaryText}
                showSecondaryText={secondaryText && secondaryText.length > 0}
                hidePersonaDetails={false}
                onRenderInitials={this.onRenderRoomIcon}
                className={className}
            />
        );

        return wrapWithLocationCard(
            name,
            null /* postalAddress */,
            emailAddress /* cardId */,
            roomElement,
            colorScheme,
            null /* onLocationCardUnmounted */
        );
    }

    private onRenderRoomIcon = (): JSX.Element => {
        return <RoomIcon backgroundColor={this.props.colorScheme.calPrimary} />;
    };
}
